import { MultiSelect, type MultiSelectProps } from "@mantine/core"
import { useTranslation } from "react-i18next"
import { useTeams } from "@/hooks/useTeams"

export function TeamsSelect(props: MultiSelectProps) {
  const { t } = useTranslation()
  const { teams } = useTeams()
  const data = teams.map((t) => ({
    value: t.id,
    label: t.name,
  }))
  return (
    <MultiSelect
      w="100%"
      label={t("Department")}
      placeholder={t("Select department")}
      comboboxProps={{
        withinPortal: true,
      }}
      {...props}
      data={data}
    />
  )
}
